import { podoFetcher } from '@server/infrastructure/external-apis/podo/client'

import { homeBannersResponseSchema, type HomeBannerPlacement, type HomeBannersResponse } from '../model'

const BANNER_ENDPOINTS: Record<HomeBannerPlacement, string> = {
  HOME: '/api/v1/home/banners',
  JP_PLAN: '/api/v1/banners/jp-plan',
  JP_TRIAL: '/api/v1/banners/jp-trial',
}

type HomeBannerRequestOptions = RequestQueryOptionalOptions<{
  placement?: HomeBannerPlacement
  countryCode?: string | null
  signal?: AbortSignal
  timeoutMs?: number
}>

export const getHomeBanners = async ({
  bearerToken,
  placement = 'HOME',
  signal,
  timeoutMs,
}: HomeBannerRequestOptions): Promise<HomeBannersResponse> => {
  const response = await podoFetcher<unknown>(
    {
      method: 'GET',
      url: BANNER_ENDPOINTS[placement],
      header: bearerToken ? { Authorization: `Bearer ${bearerToken}` } : {},
    },
    {
      throwOnErrorResult: true,
      ...(signal ? { signal } : {}),
      ...(timeoutMs !== undefined ? { timeoutMs } : {}),
    },
  )

  return homeBannersResponseSchema.parse(response.data)
}
